import React from 'react';
import * as Styles from './styles';
import { SnappyAnimation } from './SnappyAnimation/SnappyAnimation';
import SnappyLoaderBuilder from './media/snappy-loader-builder.png';
import { withI18n } from 'react-i18next';

const LoaderPage = ({
  t,
  progress = null,
  title = t('loaderPage.title'),
  description,
  borderRadius = 0,
  isLoaderBuilder,
}) => (
  <Styles.Wrapper borderRadius={borderRadius} data-testid="loader-page-wrapper">
    <Styles.LoaderWrapper $isLoaderBuilder={isLoaderBuilder}>
      {isLoaderBuilder ? (
        <Styles.LoaderBuilderImage
          src={SnappyLoaderBuilder}
          data-testid="loader-builder-image"
        />
      ) : (
        <SnappyAnimation />
      )}

      {(progress !== null && progress !== undefined) && (
      <Styles.ProgressBarContainer>
        <Styles.Progress percentage={progress} />
      </Styles.ProgressBarContainer>
      )}
    </Styles.LoaderWrapper>

    {title && <Styles.LoaderTitle>{title}</Styles.LoaderTitle>}
    {description && <Styles.LoaderDescription>{description}</Styles.LoaderDescription>}
  </Styles.Wrapper>
);


export default withI18n()(LoaderPage);
